<template>
    <SocialAuthenticationButtons
        type="register"
        :google-title="translate('Sign up with %provider%',{ '%provider%': 'Google' })"
        :google-text="translate('Sign up with %provider%',{ '%provider%': 'Google' })"
        :facebook-title="translate('Sign up with %provider%',{ '%provider%': 'Facebook' })"
        :facebook-text="translate('Continue with %provider%',{ '%provider%': 'Facebook' })"
        :apple-title="translate('Log in with %provider%',{ '%provider%': 'Apple' })"
        :apple-text="translate('Sign up with %provider%',{ '%provider%': 'Apple' })"
        :microsoft-title="translate('Log in with %provider%',{ '%provider%': 'Microsoft' })"
        :microsoft-text="translate('Sign up with %provider%',{ '%provider%': 'Microsoft' })"
        :reload-page="reloadPage"
        @auth-success="$emit('auth-success')"
        @auth-fail="$emit('auth-fail')"
    ></SocialAuthenticationButtons>
</template>

<script>
import SocialAuthenticationButtons from './SocialAuthenticationButtons';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    name: 'SocialSignupButtons',
    components: { SocialAuthenticationButtons },
    mixins: [TransFilter],
    props: {
        reloadPage: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
